// extracted by mini-css-extract-plugin
export var colorSquare = "_nd-0";
export var danger = "_nd-5";
export var lightPink = "_nd-8";
export var neutralBlue = "_nd-7";
export var neutralYellow = "_nd-6";
export var normal = "_nd-1";
export var primary = "_nd-2";
export var primaryLight = "_nd-3";
export var solidBlack = "_nd-g";
export var solidGreen = "_nd-b";
export var solidLightBlue = "_nd-d";
export var solidNavy = "_nd-c";
export var solidOrange = "_nd-f";
export var solidPink = "_nd-e";
export var solidRed = "_nd-9";
export var solidYellow = "_nd-a";
export var success = "_nd-4";